import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SurveyService } from '@rspl-api';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as fromActions from './survey.actions';

@Injectable()
export class SurveyEffects {
  getSurveys = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getSurveys),
      switchMap((params) =>
        this.service.filter(params.findParams).pipe(
          map((results) => {
            return fromActions.getSurveysSuccess({
              resultsCount: results.totalResults,
              results: results.results,
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  getSurvey = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getSurvey),
      switchMap((params) =>
        this.service.find(params.id).pipe(
          map((result) => {
            return fromActions.getSurveySuccess({
              survey: result,
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  createSurvey = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.createSurvey),
      switchMap((payload) => {
        return this.service.create(payload.survey).pipe(
          map((result) => {
            return fromActions.createSurveySuccess({
              survey: result,
            });
          }),
          catchError(() => EMPTY),
        );
      }),
    );
  });

  updateSurvey = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.updateSurvey),
      switchMap((payload) => {
        return this.service.update(payload.survey.id, payload.survey).pipe(
          map((result) => {
            return fromActions.updateSurveySuccess({
              survey: result,
            });
          }),
          catchError(() => EMPTY),
        );
      }),
    );
  });

  deleteSurvey = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.deleteSurvey),
      switchMap((params) =>
        this.service.delete(params.surveyId).pipe(
          map(() => {
            return fromActions.deleteSurveySuccess({
              surveyId: params.surveyId,
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  restoreSurvey = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.restoreSurvey),
      switchMap((params) =>
        this.service.restore(params.surveyId).pipe(
          map(() => {
            return fromActions.restoreSurveySuccess({
              surveyId: params.surveyId,
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private service: SurveyService,
  ) {}
}
